import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.search.filter;

const getSearchFilter = createSelector(getData, filter => filter);

export default getSearchFilter;



// WEBPACK FOOTER //
// ./src/_selectors/searchSelectors/getSearchFilter.js